import React from 'react';
import { Illustration, Typography } from '@saviynt/design-system';

import { type Blogs } from '../../services/types';
import { useInvertedLocalize } from '../../utils';

import invertedMessages from './messages';

import './ExternalBlog.css';

interface ExternalBlogProps {
  data: Blogs[];
}

function ExternalBlog({ data }: ExternalBlogProps) {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <div className='Ext-ExternalBlog-container'>
      {data.map((blog) => (
        <div className='Ext-ExternalBlog-container-blog'>
          <Typography kind='h3'>{blog.title}</Typography>
          <div className='Ext-ExternalBlog-container-blog-content'>
            <div>
              <Typography
                kind='body2'
                className='Ext-ExternalBlog-container-blog-content--text'
                lineLimit={3}>
                {blog.description}
              </Typography>
              <Typography
                kind='body2'
                className='Ext-ExternalBlog-container-blog-content--text'>
                <a href={blog.url} target='_blank' rel='noopener noreferrer'>
                  {l('View More...')}
                </a>
              </Typography>
            </div>
            <Illustration
              kind='Timeout'
              className='Ext-ExternalBlog-container-blog-content--timeout'
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default ExternalBlog;
